import React, { useState } from 'react'
import './dashboard.css'
import {Context as AuthContext} from '../Context/AuthContext'
import {Context as CasesContext} from '../Context/CasesContext'
import { useContext } from 'react'
import { Redirect } from 'react-router-dom'
import CountUp from 'react-countup';
import {withRouter} from 'react-router-dom'


const Dashboard = ({history}) => {
    const [toggleData, setToggleData] = useState('malaria')
    const {logout} = useContext(AuthContext)
    const {updateMalaria, updateLassa, state} = useContext(CasesContext)
 

    const showLassa = () => {
        setToggleData('lassa')
    }

    const showMalaria = () => {
        setToggleData('malaria')
    }

    // useEffect(() => {
    //     fetchMalaria()
    // }, [])


   
    const token = localStorage.getItem('token')


    
    const [totalMalaria, setTotalMalaria] = useState('')
    const [activeMalaria, setActiveMalaria] = useState('')
    const [recMalaria, setRecMalaria] = useState('')
    const [deathMalaria, setDeathMalaria] = useState('')

    const [totalLassa, setTotalLassa] = useState('')
    const [activeLassa, setActiveLassa] = useState('')
    const [recLassa, setRecLassa] = useState('')
    const [deathLassa, setDeathLassa] = useState('')

    if(!token){
        return <Redirect to='/login' />
    }
    // if(!state.malaria){
    //     return (
    //         <div style={{height:'100vh', width:'100%'}} >
    //           <div className="loader">Loading...</div>
    //         </div>
    //       )
    // }


    const resetMalariaForm = () => {
        setTotalMalaria('')
        setActiveMalaria('')
        setRecMalaria('')
        setDeathMalaria('')
    }
     
    const resetLassaForm = () => {
        setActiveLassa('')
        setTotalLassa('')
        setRecLassa('')
        setDeathLassa('')
    } 

    // console.log(state)

    const updateCallback = () => {
        setToggleData('malaria')
    }

    let dashboarddata = null;

    if(toggleData === 'malaria'){
        dashboarddata =(
            <div className="dashboard-data">
            <h1>Malaria data in Nigeria</h1>
            <div className="total-figures">
                <div>
                </div>
                <p>Total: <span><CountUp start={0} separator=',' end={state.malaria.total || 0} /></span>   </p>
                <p>Active: <CountUp start={0} end={state.malaria.active || 0 } /> </p>
                <p>Recovered: <CountUp start={0} end={state.malaria.recovered || 0} /> </p>
                <p>Deaths: <CountUp start={0} end={state.malaria.deaths || 0} />  </p>
            </div>
            </div> 
        )
    } else if(toggleData==='lassa'){
        dashboarddata = (
            
            <div className="dashboard-data">
            <h1>Lassa fever data in Nigeria</h1>
                <div className="total-figures">
                    <p>Total:  <span><CountUp start={0} separator=',' end={state.lassa.total || 0} /></span>  </p>
                    <p>Active: <CountUp start={0} end={state.lassa.active || 0 } /> </p>
                    <p>Recovered: <CountUp start={0} end={state.lassa.recovered || 0} /> </p>
                    <p>Deaths: <CountUp start={0} end={state.lassa.deaths || 0} /> </p>
                </div>    
            </div>
        )
    } else if(toggleData === 'editmalaria'){
        dashboarddata = (
            <form className='form' onSubmit={(e) => {
                e.preventDefault()
                updateMalaria({total:totalMalaria, active:activeMalaria, recovered:recMalaria, deaths:deathMalaria, onSuccess:updateCallback})
                resetMalariaForm()
            }}>
                <input value={totalMalaria} onChange={(e) => setTotalMalaria(e.target.value)} type="text" placeholder='Total Malaria cases in Nigeria' required />
                <input type="text" value={activeMalaria} onChange={e => setActiveMalaria(e.target.value)} placeholder='Total number of active Malaria cases in Nigeria' required />
                <input type="text" value={recMalaria} onChange={e => setRecMalaria(e.target.value)} placeholder='Total number of people who recovered from Malaria in Nigeria' required />
                <input type="text" value={deathMalaria} onChange={e => setDeathMalaria(e.target.value)}  placeholder='Total number of deaths from Malaria in Nigeria' required />
                <button  className='button'>Save</button>
            </form>
        )
    } else if (toggleData === 'editlassa'){
        dashboarddata = (
            <form className='form' onSubmit={(e) => {
                e.preventDefault()
                updateLassa({total:totalLassa, active:activeLassa, recovered:recLassa, deaths:deathLassa, onSuccess:updateCallback})
                resetLassaForm()
            }} >
                <input type="text" value={totalLassa} onChange={e=>setTotalLassa(e.target.value)} placeholder='Total Lassa Fever cases in Nigeria' required />
                <input type="text" value={activeLassa} onChange={e=>setActiveLassa(e.target.value)} placeholder='Total number of active Lassa fever cases in Nigeria' required />
                <input type="text" value={recLassa} onChange={e => setRecLassa(e.target.value)} placeholder='Total number of people who recovered from Lassa Fever' required />
                <input type="text" value={deathLassa} onChange={d=>setDeathLassa(d.target.value)} placeholder='Total number of deaths from Lassa Fever in Nigeria' required />
                <button className='button'>Save</button>
            </form>
        )
    } else if(!state.malaria){
        dashboarddata = (
            <h1>Enter data</h1>
        )
    }
    return (
        <div className='dashboard' >
            <div className='dashboard__sidebar'>
                <ul onClick={showMalaria} className='dashboard__sidebar-data' >
                     <li className='data-list malaria-tab' style={{textAlign:'center', marginBottom:20}} >Malaria data</li>
                </ul>

                <ul onClick={showLassa} className='dashboard__sidebar-data' >
                   <li className='data-list lassa-tab' style={{textAlign:'center'}} >Lassa Fever data</li> 
                </ul>

                <ul onClick={() => setToggleData('editmalaria')} className='dashboard__sidebar-data' >
                   <li className='data-list lassa-tab' style={{textAlign:'center'}} >Edit/Configure data for Malaria </li> 
                </ul>

                <ul onClick={() => setToggleData('editlassa')} className='dashboard__sidebar-data' >
                   <li className='data-list lassa-tab' style={{textAlign:'center'}} >Edit/Configure data for Lassa Fever</li> 
                </ul>

                <div style={{alignSelf:'flex-end', marginTop:50}} >
                    <button className='button' onClick={logout} >Logout</button>
                </div>
            </div>
            <div className="dashboard__details-form">
                {dashboarddata}
            </div>
        </div>
    )
}

export default withRouter(Dashboard);
